import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { Button, Card, Grid } from '@mui/material'
import dayjs, { Dayjs } from 'dayjs'
import OutboxIcon from '@mui/icons-material/Outbox'

import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import useAxios, { axiosInstance } from '../../../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../../../types/pagination'
import LeadListFollowFilter, {
  IFilterMapped,
} from './components/LeadListFollowFilter'
import LeadListFollowTable from './components/LeadListFollowTable'
import PageUrls from '../../../../../../constants/page-urls'
import { EExpiredDateStatus, ILead } from '../../../../../../types/lead'
import {
  ETrackingNotificationsStatusCalled,
  ETrackingNotificationsStatusFollow,
  ITrackingNotifications,
} from '../../../../../../types/trackingNotification'
import { message } from 'antd'
import { SendLeadFormModal } from '../../components/SendLeadFormModal'
import { MAX_DONWLOAD_PAGE_SIZE } from '../../../../../../constants/global'
import * as XLSX from 'xlsx'

const Menus: any[] = []

const LeadListFollowPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)

  const [selectedLeads, setSelectedLeads] = useState<ILead[]>([])
  const [isModalSendLead, setIsModalSendLead] = useState<boolean>(false)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    startDate: queryStr.startDate
      ? dayjs(String(queryStr.startDate)).startOf('day').format()
      : undefined,
    endDate: queryStr.endDate
      ? dayjs(String(queryStr.endDate)).endOf('day').format()
      : undefined,
    assignToObjectId: queryStr.assignToObjectId
      ? String(queryStr.assignToObjectId)
      : undefined,
    expiredDateStatus: queryStr.expiredDateStatus
      ? (String(queryStr.expiredDateStatus) as EExpiredDateStatus)
      : undefined,
    followStatus: queryStr.followStatus
      ? (String(queryStr.followStatus) as ETrackingNotificationsStatusFollow)
      : undefined,
    calledStatus: queryStr.calledStatus
      ? (String(queryStr.calledStatus) as ETrackingNotificationsStatusCalled)
      : undefined,
  })
  const onFilterChange = useCallback(
    (newFilter: IFilterMapped) => {
      setFilter(newFilter)
    },
    [setFilter],
  )

  const handleSearch = (newFilter: IFilterMapped) => {
    const filter = {
      ...newFilter,
      page: 1,
    }
    setFilter(filter)
    setSearchFilter(filter)
    const newQuery = queryString.stringify({ ...filter })
    navigate(`${PageUrls.CRM.Lead.Follow}?${newQuery}`, {
      replace: true,
    })
  }

  const handleResetFilter = () => {
    const filter = {
      page: 1,
      perPage: 15,
    }
    setFilter(filter)
    window.location.href = PageUrls.CRM.Lead.Follow
    // setSearchFilter(filter)
    // const newQuery = queryString.stringify({ ...filter })
    // navigate(`${PageUrls.CRM.Lead.Follow}?${newQuery}`, {
    //   replace: true,
    // })
  }

  const handlePageChange = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.CRM.Lead.Follow}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const params = {
    ...searchFilter,
    calledStatus:
      (searchFilter?.calledStatus as any) == 'all'
        ? undefined
        : searchFilter.calledStatus,
    followStatus:
      (searchFilter?.followStatus as any) == 'all'
        ? undefined
        : searchFilter.followStatus,
    expiredDateStatus:
      (searchFilter?.expiredDateStatus as any) == 'all'
        ? undefined
        : searchFilter.expiredDateStatus,
  }
  const trackingNotificationList = useAxios<
    PaginationResponseInterface<ITrackingNotifications>
  >({
    method: 'GET',
    url: '/lead/tracking-notification',
    params,
  })

  const handleOnDownload = useCallback(
    async (date: Dayjs) => {
      let loop = true
      let page = 1,
        perPage = MAX_DONWLOAD_PAGE_SIZE
      const data: ITrackingNotifications[] = []

      let startDate = params?.startDate
      let endDate = params?.endDate

      if (
        !startDate ||
        !endDate ||
        dayjs(endDate).diff(dayjs(startDate), 'day') > 31
      ) {
        startDate = date.startOf('month').format('YYYY-MM-DD')
        endDate = date.endOf('month').format('YYYY-MM-DD')
      }

      while (loop) {
        try {
          const result = await axiosInstance.get(
            '/lead/tracking-notification',
            {
              params: {
                ...params,
                page,
                perPage,
                startDate,
                endDate,
              },
            },
          )
          page++
          if (!result?.data?.records.length) {
            loop = false
            break
          }
          data.push(...result.data.records)
          if (result?.data?.count < perPage) {
            loop = false
            break
          }
        } catch (e) {
          message.warning('เกิดข้อผิดพลาดในการดาวน์โหลดข้อมูลบางส่วน')
          break
        }
      }
      if (!data.length) {
        message.warning('ไม่พบข้อมูล')
        return
      }
      const rows = data?.map((dt: ITrackingNotifications) => {
        return {
          วันที่แจ้งเตือน: dt?.expiredAt
            ? dayjs(dt.expiredAt).format('DD/MM/YYYY HH:mm')
            : '',
          'รายการ LEAD': dt.lead?.name,
          ผู้ดูแล: dt.assignTo?.name,
          PIPLINE: dt.lead.pipelineName,
          สถานะ: dt.lead.activePipelineItemName,
          สถานะการติดตาม:
            dt.statusFollow === ETrackingNotificationsStatusFollow.WAIT
              ? 'ยังไม่ติดตาม'
              : 'ติดตามแล้ว',
          การโทร:
            dt.statusCalled === ETrackingNotificationsStatusCalled.NOT_CALLED
              ? 'ยังไม่โทร'
              : dt.statusCalled === ETrackingNotificationsStatusCalled.CALLED
                ? 'โทรแล้ว'
                : 'ยกเลิกการโทร',
          หมายเหตุ: dt.note ?? '',
        }
      })
      const ws = XLSX.utils.json_to_sheet(rows)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
      XLSX.writeFile(wb, `lead-follow.xlsx`)
      message.success('ดาวน์โหลดสำเร็จ')
    },
    [params],
  )

  const onUpdateTrackingNotificationListSuccess = useCallback(async () => {
    try {
      await trackingNotificationList.mutate()
    } catch (error) {
      message.error('เกิดข้อผิดพลาดในการอัพเดทข้อมูล')
    }
  }, [trackingNotificationList])

  return (
    <ContentWrapper>
      <Helmet title="รายการแจ้งเตือนติดตามลูกค้า" />
      <SendLeadFormModal
        objectIds={selectedLeads.map((lead) => lead.objectId!)}
        isOpen={isModalSendLead}
        onClose={(visible: boolean) => setIsModalSendLead(visible)}
        onUpdateLeadListSuccess={onUpdateTrackingNotificationListSuccess}
      />
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="รายการแจ้งเตือนติดตามลูกค้า"
            routes={Menus}
            descriptions="รายการแจ้งเตือนติดตามลูกค้า"
            tags={[
              {
                title: 'จำนวน',
                color: 'info',
                value: trackingNotificationList.data?.count ?? 0,
                classifier: 'รายการ',
              },
            ]}
          />
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}
      >
        <LeadListFollowFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
          onResetFilter={handleResetFilter}
          onDownload={handleOnDownload}
        />
        {selectedLeads.length > 0 && (
          <Grid container spacing={2} mb={2}>
            <Grid item>
              <Button
                variant="contained"
                size="medium"
                startIcon={<OutboxIcon />}
                color={'info'}
                onClick={() => setIsModalSendLead(true)}
              >
                ส่งต่อ Lead {`(${selectedLeads.length})`}
              </Button>
            </Grid>
          </Grid>
        )}
        <LeadListFollowTable
          selectedData={selectedLeads}
          setSelectedData={setSelectedLeads}
          isLoading={trackingNotificationList.isLoading}
          data={trackingNotificationList.data?.records ?? []}
          onUpdateTrackingNotificationListSuccess={
            onUpdateTrackingNotificationListSuccess
          }
          filter={filter}
          onSearch={handleSearch}
          handlePageChange={handlePageChange}
          total={trackingNotificationList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default LeadListFollowPage
